import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import Api from "../Api/Api.json";

const fetchData = async (patient_id) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.PATIENT_API;
  const requestData = {
    task: "getPatientPrescriptionComplaintsList",
    patient_id,
  };
  const response = await axios.post(url, requestData, headers);
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  return response.data;
};

export const useComplaintsData = (patient_id) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["complaintsData", patient_id], // Unique key for this query
    queryFn: () => fetchData(patient_id), // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });
}